require('./RAAccordionRow.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @components
const RAAccordionBody = require('../RAAccordionBody/RAAccordionBody');
const RAAccordionHeader = require('../RAAccordionHeader/RAAccordionHeader');

class RAAccordionRow extends React.Component {
    render() {
        const {
            disabled,
            selectedOption,
            row,
            openedTogglerText,
            closedToggleText,
            expandAccordionRow,
            selectAccordionButton,
        } = this.props;
        const { title, text, id, icon, buttons } = row;

        const isExpanded = this.props.expandedRowId
            ? this.props.expandedRowId.includes(id)
            : false;

        const rowClassName = classnames('ra-accordion-row', {
            'ra-accordion-row--is-expanded': isExpanded,
            'ra-accordion-row--is-disabled': disabled,
        });

        return (
            <div className="ra-accordion-row-wrapper">
                <div className={rowClassName}>
                    <RAAccordionHeader
                        rowId={id}
                        pillsConfig={buttons}
                        disabled={disabled}
                        icon={icon}
                        isExpanded={isExpanded}
                        description={title}
                        selectedOption={selectedOption}
                        selectAccordionButton={selectAccordionButton}
                        togglerText={closedToggleText}
                        onAccordionClick={expandAccordionRow}
                    />
                    <RAAccordionBody
                        togglerText={openedTogglerText}
                        information={text}
                        disabled={disabled}
                        rowId={id}
                        onAccordionClick={expandAccordionRow}
                    />
                </div>
            </div>
        );
    }
}

RAAccordionRow.propTypes = {
    row: PropTypes.object,
    expandedRowId: PropTypes.string,
    expandAccordionRow: PropTypes.func.isRequired,
    selectAccordionButton: PropTypes.func.isRequired,
    selectedOption: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    closedToggleText: PropTypes.string,
    openedTogglerText: PropTypes.string,
};

module.exports = RAAccordionRow;
